import React from "react";

import "../index.scss";
import "./site/Responsive.scss";

const Footer = () => (
  <div style={{ position: 'fixed', bottom: '0em', height: '3em', backgroundColor: 'white', width: '100%' }}>
    <img className="img-fluid" style={{ marginTop: '0.5em', marginLeft: '0.2%' }} src="/images/bordura.jpg" alt="citajte o" />
  </div>
);

export default Footer;
